import React from 'react';
import { aboutContent } from '../../data/mockData';

const ValueItem = ({ value }) => (
  <li style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', color: 'var(--text-secondary)' }}>
    <div
      style={{
        width: '0.5rem',
        height: '0.5rem',
        borderRadius: '50%',
        background: 'var(--accent-gold-dark)',
        flexShrink: 0
      }}
    />
    {value}
  </li>
);

export const AboutText = () => (
  <div className="about-text">
    <h3>Our Story</h3>
    <p className="body-medium">{aboutContent.mission}</p>

    <h3>Our Vision</h3>
    <p className="body-medium">{aboutContent.vision}</p>

    <h3>Our Approach</h3>
    <p className="body-medium">{aboutContent.founderStory}</p>

    <div style={{ marginTop: '2rem' }}>
      <h4 style={{ fontSize: '1.05rem', fontWeight: 700, color: 'var(--primary-navy)', marginBottom: '0.85rem' }}>
        Our Core Values
      </h4>
      <ul style={{ listStyle: 'none', padding: 0, display: 'grid', gap: '0.6rem' }}>
        {aboutContent.values.map((v) => (
          <ValueItem key={v} value={v} />
        ))}
      </ul>
    </div>
  </div>
);
